// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   Surveys — modern enterprise design
   ===================================================== */

/* ── Shared form primitives ── */

.form-group {
  margin-bottom: 18px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 12px;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* Generic input used in new form (CreateSurveyForm / FieldBuilder) */
.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
  font-family: inherit;
}

.form-input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.12);
}

.form-input:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-input-lg {
  font-size: 15px;
  padding: 12px 14px;
}

/* Legacy .form-control used in DynamicField — keep as-is */
.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #4a90e2;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.label-optional {
  font-weight: 400;
  font-size: 11px;
  color: #9ca3af;
  text-transform: none;
  letter-spacing: 0;
  margin-left: 4px;
}

.field-hint {
  font-size: 12px;
  color: #6b7280;
  margin: 5px 0 0 0;
}

.validation-hint {
  font-size: 13px;
  color: #d97706;
  margin: 10px 0 0 0;
}

/* ── Toggle switch ── */

.toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  -webkit-user-select: none;
          user-select: none;
}

.toggle-label-sm {
  font-size: 13px;
  font-weight: 400;
  color: #6b7280;
  margin-top: 14px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}

.toggle-switch-sm {
  width: 36px;
  height: 20px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.toggle-slider {
  position: absolute;
  inset: 0;
  background: #d1d5db;
  border-radius: 24px;
  transition: background 0.2s;
  cursor: pointer;
}

.toggle-slider::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  left: 3px;
  top: 3px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toggle-switch-sm .toggle-slider::before {
  width: 14px;
  height: 14px;
  left: 3px;
  top: 3px;
}

.toggle-switch input:checked + .toggle-slider {
  background: #4a90e2;
}

.toggle-switch input:checked + .toggle-slider::before {
  transform: translateX(20px);
}

.toggle-switch-sm input:checked + .toggle-slider::before {
  transform: translateX(16px);
}

/* ── Boolean Tak/Nie button group (DynamicField) ── */

.boolean-buttons {
  display: flex;
  gap: 10px;
  margin-top: 6px;
}

.boolean-btn {
  flex: 1 1;
  max-width: 140px;
  padding: 10px 0;
  border-radius: 8px;
  border: 2px solid #e5e7eb;
  background: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  color: #6b7280;
}

.boolean-btn:hover {
  border-color: #9ca3af;
  color: #374151;
}

.boolean-btn-yes.active {
  border-color: #059669;
  background: #ecfdf5;
  color: #059669;
}

.boolean-btn-no.active {
  border-color: #ef4444;
  background: #fef2f2;
  color: #ef4444;
}

/* ── Multiple-choice option buttons (DynamicField) ── */

.mc-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.mc-option-btn {
  padding: 9px 20px;
  border-radius: 8px;
  border: 2px solid #e5e7eb;
  background: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: #374151;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
}

.mc-option-btn:hover {
  border-color: #4a90e2;
  color: #4a90e2;
}

.mc-option-btn.active {
  border-color: #4a90e2;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}

/* ── Multiple-choice options editor (FieldBuilder) ── */

.options-editor {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}

.option-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.option-input {
  flex: 1 1;
}

.option-remove-btn {
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  line-height: 1;
  transition: color 0.15s, background 0.15s;
}

.option-remove-btn:hover {
  color: #ef4444;
  background: #fef2f2;
}

.btn-add-option {
  align-self: flex-start;
  margin-top: 4px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
  background: transparent;
  border: 1px dashed #4a90e2;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-add-option:hover {
  background: #eff6ff;
}

/* ── Boolean / True-False statistics ── */

.bool-stat-row {
  display: flex;
  gap: 20px;
  margin: 6px 0 4px;
  font-size: 13px;
}

.bool-stat-yes { color: #059669; }
.bool-stat-no  { color: #ef4444; }

/* ── Multiple-choice statistics bars ── */

.mc-stat-bars {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 6px 0 4px;
}

.mc-stat-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.mc-stat-label {
  min-width: 100px;
  color: #374151;
}

.mc-bar-track {
  flex: 1 1;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.mc-bar-fill {
  height: 100%;
  background: #4a90e2;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.mc-stat-count {
  min-width: 24px;
  text-align: right;
  color: #6b7280;
  font-weight: 600;
}

/* ─────────────────────────────────────────────────────
   FILL SURVEY TAB
───────────────────────────────────────────────────── */

.fill-survey-tab h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #1f2937;
}

.surveys-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.survey-card {
  background: white;
  border-radius: 10px;
  padding: 18px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  border: 1.5px solid #f3f4f6;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.survey-card > .btn {
  flex-shrink: 0;
  width: auto;
  min-width: 110px;
  padding: 9px 20px;
  white-space: nowrap;
}

.survey-card:hover {
  border-color: #e5e7eb;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

.survey-info {
  flex: 1 1;
  min-width: 0;
}

.survey-info h4 {
  margin: 0 0 6px 0;
  font-size: 15px;
  color: #1f2937;
  font-weight: 600;
}

.survey-info p {
  margin: 3px 0;
  color: #6b7280;
  font-size: 13px;
}

.survey-description {
  color: #6b7280;
  font-size: 13px;
  margin: 4px 0;
}

.deadline {
  font-weight: 600 !important;
  color: #ef4444 !important;
}

.warning-message {
  margin-top: 8px;
  padding: 8px 12px;
  background: #fef3c7;
  border-radius: 6px;
  font-size: 13px;
}

/* Survey fill form */

.survey-form {
  background: white;
  border-radius: 10px;
  padding: 28px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.survey-form > form > .btn {
  width: auto;
  padding: 10px 28px;
  font-size: 15px;
  margin-top: 8px;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1.5px solid #f3f4f6;
}

.form-header > .btn {
  flex-shrink: 0;
  width: auto;
  padding: 7px 18px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.form-header h4 {
  margin: 0;
  color: #1f2937;
  font-size: 16px;
}

/* Rating field (DynamicField) */

.rating-field {
  margin-bottom: 24px;
}

.rating-field label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #1f2937;
}

.field-description {
  color: #6b7280;
  font-size: 13px;
  margin: 4px 0 10px 0;
  font-style: italic;
}

.rating-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.rating-btn {
  width: 48px;
  height: 48px;
  border: 2px solid #e5e7eb;
  background: white;
  border-radius: 8px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  color: #374151;
}

.rating-btn:hover {
  border-color: #4a90e2;
  background: #eff6ff;
}

.rating-btn.active {
  background: #4a90e2;
  color: white;
  border-color: #4a90e2;
}

/* ─────────────────────────────────────────────────────
   RESULTS TAB
───────────────────────────────────────────────────── */

.results-tab h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
}

.survey-stats {
  margin-top: 8px;
}

.survey-stat-card {
  background: white;
  border-radius: 10px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
  border: 1.5px solid #f3f4f6;
  overflow: hidden;
}

.survey-stat-header {
  padding: 14px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9fafb;
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.15s;
}

.survey-stat-header:hover {
  background: #f3f4f6;
}

.survey-stat-header h4 {
  margin: 0;
  font-size: 14px;
  color: #1f2937;
}

.survey-stat-summary {
  display: flex;
  align-items: center;
  gap: 12px;
}

.completion-rate {
  font-weight: 600;
  color: #4a90e2;
  font-size: 13px;
}

.expand-icon {
  font-size: 13px;
  color: #9ca3af;
}

.survey-stat-details {
  padding: 20px;
}

.field-statistics {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
  margin-bottom: 24px;
}

.field-stat {
  background: #f9fafb;
  padding: 14px;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
}

.field-stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.field-stat-label {
  font-weight: 600;
  color: #374151;
  font-size: 13px;
}

.field-stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #4a90e2;
}

.field-stat-count {
  color: #9ca3af;
  font-size: 12px;
  margin-top: 4px;
}

.rating-bar-track {
  height: 6px;
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 8px;
}

.rating-bar-fill {
  height: 100%;
  transition: width 0.4s ease;
  border-radius: 3px;
}

.text-sample {
  margin-top: 10px;
  padding: 10px;
  background: white;
  border-radius: 6px;
  border: 1px solid #f3f4f6;
}

.text-sample strong {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
}

.text-sample ul {
  margin: 8px 0 0 0;
  padding-left: 18px;
}

.text-sample li {
  margin: 4px 0;
  color: #4b5563;
  font-size: 13px;
}

.responses-table-container {
  margin-top: 24px;
  overflow-x: auto;
}

.responses-table-container h5 {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 0;
}

.responses-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.responses-table th {
  background: #4a90e2;
  color: white;
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
}

.responses-table td {
  padding: 9px 12px;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
}

.responses-table tr:hover td {
  background: #f9fafb;
}

.missing-users {
  margin-top: 20px;
  padding: 14px 16px;
  background: #fef9c3;
  border-radius: 8px;
  border: 1px solid #fde047;
}

.missing-users h5 {
  margin-top: 0;
  color: #713f12;
  font-size: 13px;
}

.missing-users ul {
  margin: 8px 0 0 0;
  padding-left: 18px;
}

.missing-users li {
  font-size: 13px;
  color: #713f12;
}

.loading-details {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
  font-size: 13px;
}

/* ─────────────────────────────────────────────────────
   MANAGE TAB — survey card list
───────────────────────────────────────────────────── */

.manage-tab h3 {
  margin: 0;
  font-size: 16px;
}

.manage-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.manage-survey-card {
  background: white;
  border-radius: 10px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
  border: 1.5px solid #f3f4f6;
  overflow: hidden;
  transition: box-shadow 0.15s;
}

.manage-survey-card:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.09);
}

.msc-body {
  padding: 16px 20px 14px 20px;
}

.msc-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.msc-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}

.msc-desc {
  font-size: 13px;
  color: #6b7280;
  margin: 4px 0 10px 0;
}

.msc-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 12px;
}

.msc-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6b7280;
}

.msc-progress {
  margin-top: 2px;
}

.msc-progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 5px;
}

.msc-progress-label strong {
  color: #374151;
}

.progress-track {
  height: 6px;
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #4a90e2;
  border-radius: 3px;
  transition: width 0.4s ease;
}

.msc-actions {
  padding: 10px 20px;
  background: #f9fafb;
  border-top: 1px solid #f3f4f6;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* Status badges */

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-active {
  background: #d1fae5;
  color: #065f46;
}

.badge-inactive {
  background: #f3f4f6;
  color: #6b7280;
}

/* Outline button variant */
.btn-outline {
  background: white;
  border: 1.5px solid #d1d5db;
  color: #374151;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.btn-outline:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

/* ─────────────────────────────────────────────────────
   CREATE SURVEY FORM — sectioned layout
───────────────────────────────────────────────────── */

.create-survey-form {
  max-width: 740px;
}

/* Top bar */
.csf-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.csf-topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.csf-topbar-left h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.back-btn {
  background: none;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.back-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #374151;
}

/* Sections */
.form-section {
  background: white;
  border-radius: 12px;
  border: 1.5px solid #f3f4f6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 20px;
  background: #f9fafb;
  border-bottom: 1.5px solid #f3f4f6;
}

.section-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4a90e2;
  color: white;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-header h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #1f2937;
  flex: 1 1;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.section-badge {
  background: #dbeafe;
  color: #1e40af;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 10px;
}

.section-hint {
  font-size: 13px;
  color: #9ca3af;
  margin: 0 0 14px 0;
}

.section-body {
  padding: 18px 20px;
}

/* Department toggle chips */
.dept-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dept-chip {
  padding: 7px 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 20px;
  background: white;
  font-size: 13px;
  color: #4b5563;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
}

.dept-chip:hover {
  border-color: #4a90e2;
  background: #eff6ff;
  color: #1d4ed8;
}

.dept-chip-selected {
  border-color: #4a90e2;
  background: #4a90e2;
  color: white;
}

.dept-chip-selected:hover {
  background: #357abd;
  border-color: #357abd;
  color: white;
}

.chip-check {
  font-size: 11px;
  font-weight: 700;
}

/* Add-field buttons */
.btn-add-field {
  margin-left: auto;
  padding: 5px 14px;
  border: 1.5px dashed #4a90e2;
  border-radius: 8px;
  background: white;
  color: #4a90e2;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.btn-add-field:hover {
  background: #eff6ff;
}

.btn-add-field-bottom {
  width: 100%;
  margin-top: 8px;
  padding: 10px;
  border: 1.5px dashed #d1d5db;
  border-radius: 8px;
  background: #f9fafb;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.btn-add-field-bottom:hover {
  border-color: #4a90e2;
  color: #4a90e2;
  background: #eff6ff;
}

/* Empty state for fields section */
.fields-empty-state {
  text-align: center;
  padding: 32px 16px;
  color: #9ca3af;
}

.fields-empty-icon {
  font-size: 36px;
  margin-bottom: 10px;
}

.fields-empty-state p {
  font-size: 14px;
  margin: 0;
}

/* Edit form summary */
.survey-summary {
  background: #f9fafb;
  padding: 14px 16px;
  border-radius: 8px;
  margin-bottom: 18px;
  border: 1px solid #f3f4f6;
}

.survey-summary p {
  margin: 4px 0;
  font-size: 13px;
  color: #4b5563;
}

/* ─────────────────────────────────────────────────────
   FIELD BUILDER CARD (question editor)
───────────────────────────────────────────────────── */

.fields-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-builder-card {
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: white;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.field-card-expanded {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.field-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 14px;
  cursor: pointer;
  background: #f9fafb;
  transition: background 0.15s;
  gap: 10px;
  -webkit-user-select: none;
          user-select: none;
}

.field-card-header:hover {
  background: #f3f4f6;
}

.field-card-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1;
}

.field-card-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.field-index {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
}

.field-card-expanded .field-index {
  background: #4a90e2;
  color: white;
}

.field-type-badge {
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  white-space: nowrap;
  background: #e5e7eb;
  padding: 2px 8px;
  border-radius: 4px;
  flex-shrink: 0;
}

.field-label-preview {
  font-size: 13px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.field-label-empty {
  color: #d1d5db;
  font-style: italic;
}

.field-required-badge {
  font-size: 15px;
  color: #ef4444;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
}

.field-remove-btn {
  background: none;
  border: none;
  color: #d1d5db;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.15s;
  line-height: 1;
  font-family: inherit;
}

.field-remove-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}

.field-expand-icon {
  font-size: 10px;
  color: #9ca3af;
}

.field-card-body {
  padding: 16px;
  border-top: 1.5px solid #f3f4f6;
  background: white;
}

/* Type icon buttons */
.type-selector {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.type-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 8px 12px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.15s;
  min-width: 62px;
  font-family: inherit;
}

.type-btn:hover {
  border-color: #4a90e2;
  background: #eff6ff;
}

.type-btn-active {
  border-color: #4a90e2;
  background: #4a90e2;
  color: white;
}

.type-btn-icon {
  font-size: 18px;
  line-height: 1;
}

.type-btn-label {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.config-row {
  margin-top: 10px;
}

/* ── Responsive ── */

@media (max-width: 640px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .type-btn {
    min-width: 52px;
    padding: 6px 8px;
  }

  .type-btn-icon {
    font-size: 16px;
  }

  .msc-meta {
    flex-direction: column;
    gap: 4px;
  }

  .survey-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .msc-actions {
    flex-wrap: wrap;
  }
}


/* ── User-selection UI ─────────────────────────────────────── */

.send-all-notice {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
  border-radius: 8px;
  color: #2e7d32;
  font-size: 14px;
}

.send-all-icon {
  font-size: 20px;
}

.dept-user-panel {
  margin-top: 14px;
  border: 1px solid #dde3ec;
  border-radius: 8px;
  overflow: hidden;
}

.dup-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  background: #f0f4f8;
  border-bottom: 1px solid #dde3ec;
}

.dup-dept-name {
  font-weight: 600;
  font-size: 13px;
  color: #2c3e50;
  flex: 1 1;
}

.dup-count {
  font-size: 12px;
  color: #555;
  background: #dde3ec;
  padding: 2px 8px;
  border-radius: 12px;
}

.dup-toggle-all-btn {
  font-size: 12px;
  color: #4a90e2;
  background: none;
  border: 1px solid #4a90e2;
  border-radius: 6px;
  padding: 3px 10px;
  cursor: pointer;
  transition: background 0.15s;
}

.dup-toggle-all-btn:hover {
  background: #e8f0fc;
}

.dup-user-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 6px;
  padding: 12px 14px;
  background: #fff;
}

.dup-user-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  font-size: 13px;
  color: #444;
  transition: background 0.12s, border-color 0.12s;
  -webkit-user-select: none;
          user-select: none;
}

.dup-user-item:hover {
  background: #f5f8ff;
}

.dup-user-item.dup-selected {
  background: #e8f0fc;
  border-color: #4a90e2;
  color: #1a56b0;
}

.dup-user-item input[type="checkbox"] {
  width: 15px;
  height: 15px;
  accent-color: #4a90e2;
  cursor: pointer;
  flex-shrink: 0;
}

.dup-user-name {
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-submit-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 0 0;
  margin-top: 8px;
  border-top: 1px solid #eaedf2;
}
.surveys-page .tab-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}

.surveys-page .tab-button > svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  stroke-width: 1.9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/Surveys.css"],"names":[],"mappings":"AAAA;;0DAE0D;;AAE1D,iCAAiC;;AAEjC;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gDAAgD;EAChD,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;;AAExB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sDAAsD;;AAEtD;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;;AAEjC,0CAA0C;;AAE1C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;uDAEuD;;AAEvD;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qBAAqB;;AAErB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;;AAEhC;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;uDAEuD;;AAEvD;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;uDAEuD;;AAEvD;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;uDAEuD;;AAEvD;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,iEAAiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,gDAAgD;EAChD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* =====================================================\n   Surveys — modern enterprise design\n   ===================================================== */\n\n/* ── Shared form primitives ── */\n\n.form-group {\n  margin-bottom: 18px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  font-size: 12px;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n/* Generic input used in new form (CreateSurveyForm / FieldBuilder) */\n.form-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1f2937;\n  background: #fff;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.12);\n}\n\n.form-input:disabled {\n  background: #f3f4f6;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-input-lg {\n  font-size: 15px;\n  padding: 12px 14px;\n}\n\n/* Legacy .form-control used in DynamicField — keep as-is */\n.form-control {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.required {\n  color: #ef4444;\n  margin-left: 2px;\n}\n\n.label-optional {\n  font-weight: 400;\n  font-size: 11px;\n  color: #9ca3af;\n  text-transform: none;\n  letter-spacing: 0;\n  margin-left: 4px;\n}\n\n.field-hint {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 5px 0 0 0;\n}\n\n.validation-hint {\n  font-size: 13px;\n  color: #d97706;\n  margin: 10px 0 0 0;\n}\n\n/* ── Toggle switch ── */\n\n.toggle-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  user-select: none;\n}\n\n.toggle-label-sm {\n  font-size: 13px;\n  font-weight: 400;\n  color: #6b7280;\n  margin-top: 14px;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.toggle-switch-sm {\n  width: 36px;\n  height: 20px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.toggle-slider {\n  position: absolute;\n  inset: 0;\n  background: #d1d5db;\n  border-radius: 24px;\n  transition: background 0.2s;\n  cursor: pointer;\n}\n\n.toggle-slider::before {\n  content: '';\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 3px;\n  top: 3px;\n  background: white;\n  border-radius: 50%;\n  transition: transform 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.toggle-switch-sm .toggle-slider::before {\n  width: 14px;\n  height: 14px;\n  left: 3px;\n  top: 3px;\n}\n\n.toggle-switch input:checked + .toggle-slider {\n  background: #4a90e2;\n}\n\n.toggle-switch input:checked + .toggle-slider::before {\n  transform: translateX(20px);\n}\n\n.toggle-switch-sm input:checked + .toggle-slider::before {\n  transform: translateX(16px);\n}\n\n/* ── Boolean Tak/Nie button group (DynamicField) ── */\n\n.boolean-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.boolean-btn {\n  flex: 1;\n  max-width: 140px;\n  padding: 10px 0;\n  border-radius: 8px;\n  border: 2px solid #e5e7eb;\n  background: white;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n  color: #6b7280;\n}\n\n.boolean-btn:hover {\n  border-color: #9ca3af;\n  color: #374151;\n}\n\n.boolean-btn-yes.active {\n  border-color: #059669;\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.boolean-btn-no.active {\n  border-color: #ef4444;\n  background: #fef2f2;\n  color: #ef4444;\n}\n\n/* ── Multiple-choice option buttons (DynamicField) ── */\n\n.mc-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.mc-option-btn {\n  padding: 9px 20px;\n  border-radius: 8px;\n  border: 2px solid #e5e7eb;\n  background: white;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #374151;\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n}\n\n.mc-option-btn:hover {\n  border-color: #4a90e2;\n  color: #4a90e2;\n}\n\n.mc-option-btn.active {\n  border-color: #4a90e2;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-weight: 600;\n}\n\n/* ── Multiple-choice options editor (FieldBuilder) ── */\n\n.options-editor {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.option-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.option-input {\n  flex: 1;\n}\n\n.option-remove-btn {\n  background: none;\n  border: none;\n  color: #9ca3af;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  line-height: 1;\n  transition: color 0.15s, background 0.15s;\n}\n\n.option-remove-btn:hover {\n  color: #ef4444;\n  background: #fef2f2;\n}\n\n.btn-add-option {\n  align-self: flex-start;\n  margin-top: 4px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #4a90e2;\n  background: transparent;\n  border: 1px dashed #4a90e2;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-add-option:hover {\n  background: #eff6ff;\n}\n\n/* ── Boolean / True-False statistics ── */\n\n.bool-stat-row {\n  display: flex;\n  gap: 20px;\n  margin: 6px 0 4px;\n  font-size: 13px;\n}\n\n.bool-stat-yes { color: #059669; }\n.bool-stat-no  { color: #ef4444; }\n\n/* ── Multiple-choice statistics bars ── */\n\n.mc-stat-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 6px 0 4px;\n}\n\n.mc-stat-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.mc-stat-label {\n  min-width: 100px;\n  color: #374151;\n}\n\n.mc-bar-track {\n  flex: 1;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.mc-bar-fill {\n  height: 100%;\n  background: #4a90e2;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.mc-stat-count {\n  min-width: 24px;\n  text-align: right;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n/* ─────────────────────────────────────────────────────\n   FILL SURVEY TAB\n───────────────────────────────────────────────────── */\n\n.fill-survey-tab h3 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  color: #1f2937;\n}\n\n.surveys-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.survey-card {\n  background: white;\n  border-radius: 10px;\n  padding: 18px 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  border: 1.5px solid #f3f4f6;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.survey-card > .btn {\n  flex-shrink: 0;\n  width: auto;\n  min-width: 110px;\n  padding: 9px 20px;\n  white-space: nowrap;\n}\n\n.survey-card:hover {\n  border-color: #e5e7eb;\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);\n}\n\n.survey-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.survey-info h4 {\n  margin: 0 0 6px 0;\n  font-size: 15px;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.survey-info p {\n  margin: 3px 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.survey-description {\n  color: #6b7280;\n  font-size: 13px;\n  margin: 4px 0;\n}\n\n.deadline {\n  font-weight: 600 !important;\n  color: #ef4444 !important;\n}\n\n.warning-message {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #fef3c7;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n/* Survey fill form */\n\n.survey-form {\n  background: white;\n  border-radius: 10px;\n  padding: 28px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.survey-form > form > .btn {\n  width: auto;\n  padding: 10px 28px;\n  font-size: 15px;\n  margin-top: 8px;\n}\n\n.form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1.5px solid #f3f4f6;\n}\n\n.form-header > .btn {\n  flex-shrink: 0;\n  width: auto;\n  padding: 7px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.form-header h4 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 16px;\n}\n\n/* Rating field (DynamicField) */\n\n.rating-field {\n  margin-bottom: 24px;\n}\n\n.rating-field label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.field-description {\n  color: #6b7280;\n  font-size: 13px;\n  margin: 4px 0 10px 0;\n  font-style: italic;\n}\n\n.rating-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rating-btn {\n  width: 48px;\n  height: 48px;\n  border: 2px solid #e5e7eb;\n  background: white;\n  border-radius: 8px;\n  font-size: 17px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  color: #374151;\n}\n\n.rating-btn:hover {\n  border-color: #4a90e2;\n  background: #eff6ff;\n}\n\n.rating-btn.active {\n  background: #4a90e2;\n  color: white;\n  border-color: #4a90e2;\n}\n\n/* ─────────────────────────────────────────────────────\n   RESULTS TAB\n───────────────────────────────────────────────────── */\n\n.results-tab h3 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n}\n\n.survey-stats {\n  margin-top: 8px;\n}\n\n.survey-stat-card {\n  background: white;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);\n  border: 1.5px solid #f3f4f6;\n  overflow: hidden;\n}\n\n.survey-stat-header {\n  padding: 14px 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f9fafb;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background 0.15s;\n}\n\n.survey-stat-header:hover {\n  background: #f3f4f6;\n}\n\n.survey-stat-header h4 {\n  margin: 0;\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.survey-stat-summary {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.completion-rate {\n  font-weight: 600;\n  color: #4a90e2;\n  font-size: 13px;\n}\n\n.expand-icon {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.survey-stat-details {\n  padding: 20px;\n}\n\n.field-statistics {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 14px;\n  margin-bottom: 24px;\n}\n\n.field-stat {\n  background: #f9fafb;\n  padding: 14px;\n  border-radius: 8px;\n  border: 1px solid #f3f4f6;\n}\n\n.field-stat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.field-stat-label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 13px;\n}\n\n.field-stat-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: #4a90e2;\n}\n\n.field-stat-count {\n  color: #9ca3af;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.rating-bar-track {\n  height: 6px;\n  background: #e5e7eb;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-top: 8px;\n}\n\n.rating-bar-fill {\n  height: 100%;\n  transition: width 0.4s ease;\n  border-radius: 3px;\n}\n\n.text-sample {\n  margin-top: 10px;\n  padding: 10px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #f3f4f6;\n}\n\n.text-sample strong {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n}\n\n.text-sample ul {\n  margin: 8px 0 0 0;\n  padding-left: 18px;\n}\n\n.text-sample li {\n  margin: 4px 0;\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.responses-table-container {\n  margin-top: 24px;\n  overflow-x: auto;\n}\n\n.responses-table-container h5 {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px 0;\n}\n\n.responses-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.responses-table th {\n  background: #4a90e2;\n  color: white;\n  padding: 10px 12px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.responses-table td {\n  padding: 9px 12px;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n}\n\n.responses-table tr:hover td {\n  background: #f9fafb;\n}\n\n.missing-users {\n  margin-top: 20px;\n  padding: 14px 16px;\n  background: #fef9c3;\n  border-radius: 8px;\n  border: 1px solid #fde047;\n}\n\n.missing-users h5 {\n  margin-top: 0;\n  color: #713f12;\n  font-size: 13px;\n}\n\n.missing-users ul {\n  margin: 8px 0 0 0;\n  padding-left: 18px;\n}\n\n.missing-users li {\n  font-size: 13px;\n  color: #713f12;\n}\n\n.loading-details {\n  text-align: center;\n  padding: 20px;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n/* ─────────────────────────────────────────────────────\n   MANAGE TAB — survey card list\n───────────────────────────────────────────────────── */\n\n.manage-tab h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.manage-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.manage-survey-card {\n  background: white;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);\n  border: 1.5px solid #f3f4f6;\n  overflow: hidden;\n  transition: box-shadow 0.15s;\n}\n\n.manage-survey-card:hover {\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.09);\n}\n\n.msc-body {\n  padding: 16px 20px 14px 20px;\n}\n\n.msc-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n  flex-wrap: wrap;\n}\n\n.msc-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.msc-desc {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 4px 0 10px 0;\n}\n\n.msc-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-bottom: 12px;\n}\n\n.msc-meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.msc-progress {\n  margin-top: 2px;\n}\n\n.msc-progress-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #9ca3af;\n  margin-bottom: 5px;\n}\n\n.msc-progress-label strong {\n  color: #374151;\n}\n\n.progress-track {\n  height: 6px;\n  background: #e5e7eb;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #4a90e2;\n  border-radius: 3px;\n  transition: width 0.4s ease;\n}\n\n.msc-actions {\n  padding: 10px 20px;\n  background: #f9fafb;\n  border-top: 1px solid #f3f4f6;\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n/* Status badges */\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.badge-active {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.badge-inactive {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n/* Outline button variant */\n.btn-outline {\n  background: white;\n  border: 1.5px solid #d1d5db;\n  color: #374151;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: inherit;\n}\n\n.btn-outline:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n/* ─────────────────────────────────────────────────────\n   CREATE SURVEY FORM — sectioned layout\n───────────────────────────────────────────────────── */\n\n.create-survey-form {\n  max-width: 740px;\n}\n\n/* Top bar */\n.csf-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.csf-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.csf-topbar-left h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.back-btn {\n  background: none;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 6px 12px;\n  font-size: 13px;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: inherit;\n}\n\n.back-btn:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n  color: #374151;\n}\n\n/* Sections */\n.form-section {\n  background: white;\n  border-radius: 12px;\n  border: 1.5px solid #f3f4f6;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 13px 20px;\n  background: #f9fafb;\n  border-bottom: 1.5px solid #f3f4f6;\n}\n\n.section-number {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #4a90e2;\n  color: white;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.section-header h4 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1f2937;\n  flex: 1;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.section-badge {\n  background: #dbeafe;\n  color: #1e40af;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 9px;\n  border-radius: 10px;\n}\n\n.section-hint {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0 0 14px 0;\n}\n\n.section-body {\n  padding: 18px 20px;\n}\n\n/* Department toggle chips */\n.dept-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.dept-chip {\n  padding: 7px 16px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 20px;\n  background: white;\n  font-size: 13px;\n  color: #4b5563;\n  cursor: pointer;\n  transition: all 0.15s;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: inherit;\n}\n\n.dept-chip:hover {\n  border-color: #4a90e2;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.dept-chip-selected {\n  border-color: #4a90e2;\n  background: #4a90e2;\n  color: white;\n}\n\n.dept-chip-selected:hover {\n  background: #357abd;\n  border-color: #357abd;\n  color: white;\n}\n\n.chip-check {\n  font-size: 11px;\n  font-weight: 700;\n}\n\n/* Add-field buttons */\n.btn-add-field {\n  margin-left: auto;\n  padding: 5px 14px;\n  border: 1.5px dashed #4a90e2;\n  border-radius: 8px;\n  background: white;\n  color: #4a90e2;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: inherit;\n}\n\n.btn-add-field:hover {\n  background: #eff6ff;\n}\n\n.btn-add-field-bottom {\n  width: 100%;\n  margin-top: 8px;\n  padding: 10px;\n  border: 1.5px dashed #d1d5db;\n  border-radius: 8px;\n  background: #f9fafb;\n  color: #6b7280;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: inherit;\n}\n\n.btn-add-field-bottom:hover {\n  border-color: #4a90e2;\n  color: #4a90e2;\n  background: #eff6ff;\n}\n\n/* Empty state for fields section */\n.fields-empty-state {\n  text-align: center;\n  padding: 32px 16px;\n  color: #9ca3af;\n}\n\n.fields-empty-icon {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n\n.fields-empty-state p {\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Edit form summary */\n.survey-summary {\n  background: #f9fafb;\n  padding: 14px 16px;\n  border-radius: 8px;\n  margin-bottom: 18px;\n  border: 1px solid #f3f4f6;\n}\n\n.survey-summary p {\n  margin: 4px 0;\n  font-size: 13px;\n  color: #4b5563;\n}\n\n/* ─────────────────────────────────────────────────────\n   FIELD BUILDER CARD (question editor)\n───────────────────────────────────────────────────── */\n\n.fields-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.field-builder-card {\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  background: white;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.field-card-expanded {\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);\n}\n\n.field-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 11px 14px;\n  cursor: pointer;\n  background: #f9fafb;\n  transition: background 0.15s;\n  gap: 10px;\n  user-select: none;\n}\n\n.field-card-header:hover {\n  background: #f3f4f6;\n}\n\n.field-card-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n}\n\n.field-card-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.field-index {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #e5e7eb;\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.15s, color 0.15s;\n}\n\n.field-card-expanded .field-index {\n  background: #4a90e2;\n  color: white;\n}\n\n.field-type-badge {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4b5563;\n  white-space: nowrap;\n  background: #e5e7eb;\n  padding: 2px 8px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.field-label-preview {\n  font-size: 13px;\n  color: #374151;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.field-label-empty {\n  color: #d1d5db;\n  font-style: italic;\n}\n\n.field-required-badge {\n  font-size: 15px;\n  color: #ef4444;\n  font-weight: 700;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.field-remove-btn {\n  background: none;\n  border: none;\n  color: #d1d5db;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  transition: all 0.15s;\n  line-height: 1;\n  font-family: inherit;\n}\n\n.field-remove-btn:hover {\n  background: #fee2e2;\n  color: #ef4444;\n}\n\n.field-expand-icon {\n  font-size: 10px;\n  color: #9ca3af;\n}\n\n.field-card-body {\n  padding: 16px;\n  border-top: 1.5px solid #f3f4f6;\n  background: white;\n}\n\n/* Type icon buttons */\n.type-selector {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n\n.type-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  padding: 8px 12px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.15s;\n  min-width: 62px;\n  font-family: inherit;\n}\n\n.type-btn:hover {\n  border-color: #4a90e2;\n  background: #eff6ff;\n}\n\n.type-btn-active {\n  border-color: #4a90e2;\n  background: #4a90e2;\n  color: white;\n}\n\n.type-btn-icon {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.type-btn-label {\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.config-row {\n  margin-top: 10px;\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 640px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .type-btn {\n    min-width: 52px;\n    padding: 6px 8px;\n  }\n\n  .type-btn-icon {\n    font-size: 16px;\n  }\n\n  .msc-meta {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .survey-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .msc-actions {\n    flex-wrap: wrap;\n  }\n}\n\n\n/* ── User-selection UI ─────────────────────────────────────── */\n\n.send-all-notice {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  background: #e8f5e9;\n  border: 1px solid #a5d6a7;\n  border-radius: 8px;\n  color: #2e7d32;\n  font-size: 14px;\n}\n\n.send-all-icon {\n  font-size: 20px;\n}\n\n.dept-user-panel {\n  margin-top: 14px;\n  border: 1px solid #dde3ec;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.dup-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 14px;\n  background: #f0f4f8;\n  border-bottom: 1px solid #dde3ec;\n}\n\n.dup-dept-name {\n  font-weight: 600;\n  font-size: 13px;\n  color: #2c3e50;\n  flex: 1;\n}\n\n.dup-count {\n  font-size: 12px;\n  color: #555;\n  background: #dde3ec;\n  padding: 2px 8px;\n  border-radius: 12px;\n}\n\n.dup-toggle-all-btn {\n  font-size: 12px;\n  color: #4a90e2;\n  background: none;\n  border: 1px solid #4a90e2;\n  border-radius: 6px;\n  padding: 3px 10px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.dup-toggle-all-btn:hover {\n  background: #e8f0fc;\n}\n\n.dup-user-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 6px;\n  padding: 12px 14px;\n  background: #fff;\n}\n\n.dup-user-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid #e0e0e0;\n  font-size: 13px;\n  color: #444;\n  transition: background 0.12s, border-color 0.12s;\n  user-select: none;\n}\n\n.dup-user-item:hover {\n  background: #f5f8ff;\n}\n\n.dup-user-item.dup-selected {\n  background: #e8f0fc;\n  border-color: #4a90e2;\n  color: #1a56b0;\n}\n\n.dup-user-item input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  accent-color: #4a90e2;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.dup-user-name {\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.form-submit-footer {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 16px 0 0;\n  margin-top: 8px;\n  border-top: 1px solid #eaedf2;\n}\n.surveys-page .tab-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n}\n\n.surveys-page .tab-button > svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  stroke-width: 1.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
